import _axios from '../../apiClient'

export function GetAllLocalidadesEntrega() {
  return _axios
    .get(`/api/LocalidadEntrega/GetAllLocalidadesEntrega`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log('Error en la petición de localidad de entrega:', error)
      const data = error.response.data
      throw data
    });
}

export function GetLocalidadEntrega(idLocalidadEntrega) {
  return _axios
    .get(`/api/LocalidadEntrega/GetLocalidadEntrega/${idLocalidadEntrega}`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log('Error en la petición de localidad de entrega:', error)
      const data = error.response.data
      throw data
    });
}

export function getLocalidadEntregaByNombre(nombre) {
  return _axios.get(`/api/LocalidadEntrega/GetLocalidadEntregaByNombre`, {
      params: { nombre },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function saveLocalidadEntrega(payload) {
  return _axios.post(`/api/LocalidadEntrega/SaveLocalidadEntrega`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function deleteLocalidadEntrega(idLocalidadEntrega) {
  return _axios.delete(`/api/LocalidadEntrega/DeleteLocalidadEntrega/${idLocalidadEntrega}`, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data;
    throw (data);
  });
}